module.exports = "https://static.wanderu.com/static/media/thrillist-x2.a8d99c79.png";